import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import { LangConstant } from "const";
import { Pagination } from "components";
import dayjs from "dayjs";

const UserActivityTable = ({ limitation, page, setPage, userActivities, isLoading }) => {
  const { t: getLabel } = useTranslation();

  const tableUserActivities = getLabel(LangConstant.OBJ_TABLE_USER_ACTIVITIES, { returnObjects: true });
  const tableUserActivityTypes = getLabel(LangConstant.OBJ_USER_ACTIVITIES, { returnObjects: true });

  const tableHeaderField = [
    { label: tableUserActivities.number, width: "10%" },
    { label: tableUserActivities.user, width: "20%" },
    { label: tableUserActivities.action, width: "30%" },
    { label: tableUserActivities.time, width: "20%" },
    { label: tableUserActivities.ipAddress, width: "20%" },
  ];

  const handlePageChange = (_, newPage) => {
    setPage(newPage);
  };

  const handleGetActionName = actionType => {
    return tableUserActivityTypes[actionType];
  };

  const handleConvertTime = timestamp => {
    try {
      return dayjs(timestamp).format("DD/MM/YYYY HH:mm");
    } catch (error) {
      return "";
    }
  };

  const totalPages = Math.ceil(userActivities.totalElements / limitation);

  return (
    <div>
      <div className="card" >
        <div className="table-responsive">
          <table className="table table-vcenter">
            <thead>
              <tr>
                {tableHeaderField.map(item => (
                  <th key={item.label} style={{ width: item.width, fontWeight: "bold", fontSize: 14 }}>
                    {item.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan={5} className="text-center">
                    <div className="d-flex align-items-center justify-content-center gap-2 py-3">
                      <span className="spinner-border spinner-border-sm text-primary"></span>
                      <small>{getLabel(LangConstant.TXT_LOADING)}</small>
                    </div>
                  </td>
                </tr>
              ) : userActivities.data && userActivities.data.length > 0 ? (
                userActivities.data.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td style={{ fontSize: 14 }}>{(page - 1) * limitation + (index + 1)}</td>
                      <td style={{ fontSize: 14 }}>
                        {item.user_name && item.user_name !== "" ? item.user_name : item.user_id}
                      </td>
                      <td style={{ fontSize: 14 }}>{handleGetActionName(item.action_type)}</td>
                      <td style={{ fontSize: 14 }}>{handleConvertTime(item.created)}</td>
                      <td style={{ fontSize: 14 }}>{item.ip_address}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={5} className="text-center">
                    <small>
                      <i>{getLabel(LangConstant.TXT_NOT_FOUND)}</i>
                    </small>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {totalPages > 1 && (
        <Pagination currentPage={page} totalPages={totalPages} onPageChange={handlePageChange} />
      )}
    </div>
  );
};

export default memo(UserActivityTable);
